module.exports = __webpack_public_path__ + "img/about-background1.9a516b8a.png";